import type { ReactNode } from 'react';
import { Surface } from '@didto/ui';
import { ConnectionBanner, SyncPill } from '@/app/connection';
import { useSyncStatus } from '@/lib/network';
import { env } from '@/lib/env';

export function AuthFrame({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
}) {
  const sync = useSyncStatus();
  return (
    <div className="auth">
      <div className="auth__card">
        <ConnectionBanner>
          Signing in needs the server: it waits until the connection is back.
        </ConnectionBanner>
        <div className="auth__brand">
          <div>
            <span className="shell__logo">didto.</span> <span className="shell__product">OS</span>
          </div>
          <h1>{title}</h1>
          {subtitle && <p className="d-muted">{subtitle}</p>}
        </div>
        <Surface>{children}</Surface>
        <div className="auth__foot">
          <SyncPill state={sync.state} pending={sync.pending} />
          <span className="d-faint d-mono auth__version">v{env.appVersion}</span>
        </div>
      </div>
    </div>
  );
}
